import { render } from "./AuDecimalIcon.vue?vue&type=template&id=9127cb64&scoped=true"
import script from "./AuDecimalIcon.vue?vue&type=script&lang=js"
export * from "./AuDecimalIcon.vue?vue&type=script&lang=js"

import "./AuDecimalIcon.vue?vue&type=style&index=0&id=9127cb64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9127cb64"]])

export default __exports__